<div *ngIf="session" class="session container" xmlns="http://www.w3.org/1999/html">

    <div class="title-session-deleted">
        <h1>
            <i class="fa fa-bookmark-o fa-pre" aria-hidden="true"></i>
            {{session.title}}
            <span *ngIf="session.linkedTraining">({{session.linkedTraining.title}})</span>
            <span *ngIf="!session.linkedTraining && session.subject">({{session.subject}})</span>
            <div class="reference">{{session.reference}}</div>
        </h1>
        <h2 class="deleted-session badge badge-secondary" *ngIf="session.deleted">{{'session-details.sessionDeleted'| translate}}</h2>
    </div>

    <div class="resume">
        <div class="infos">
            <div class="icon-set date">
                <i class="fa fa-calendar" aria-hidden="true"></i>
                <span>{{ 'session-details.date' | translate}}</span>
                <span class="info-resume">{{session.startDate | formatdatepipe}}</span>
                <span>{{session.days}} {{ 'session-details.days' | translate}}</span>
            </div>
            <div class="icon-set type" *ngIf="session.type === 'intra'">
                <i class="fa fa-building" aria-hidden="true"></i>
                <span>{{ 'session-details.type' | translate}}</span>
                <span class="info-resume">Intra-entreprise</span>
                <span *ngIf="session.location && session.room">{{ 'session-details.room' | translate}} {{session.room}}</span>
            </div>
            <div class="icon-set type" *ngIf="session.type === 'inter'">
                <i class="fa fa-users" aria-hidden="true"></i>
                <span>{{ 'session-details.type' | translate}}</span>
                <span class="info-resume">Inter-entreprise</span>
            </div>
            <div class="icon-set type" *ngIf="session.type === 'ondemand'">
                <i class="fa fa-users" aria-hidden="true"></i>
                <span>{{ 'session-details.type' | translate}}</span>
                <span class="info-resume">E-learning/Voucher</span>
            </div>
            <div class="icon-set type" *ngIf="session.type === 'autre'">
                <i class="fa fa-building" aria-hidden="true"></i>
                <span>{{ 'session-details.type' | translate}}</span>
                <span class="info-resume">Autre</span>
            </div>
            <div class="icon-set language">
                <i class="fa fa-language" aria-hidden="true"></i>
                <span>{{ 'global.language.label' | translate}}</span>
                <span class="info-resume">
                    {{'global.language.' + (session.language == null ? "undefined" : session.language) | translate}}
                </span>
            </div>
            <div class="trainer">
                <img class="img-circle" src="https://via.placeholder.com/100/FAFAFA/EE2238?text={{session.trainer | initials}}">
                <span class="name">{{session.trainer}}</span>
                <span *ngFor="let additionalTrainer of session.additionalTrainers">{{additionalTrainer.fullName}}</span>
            </div>
        </div>
    </div>

    <div>
        <ul class="nav nav-tabs nav-justified" role="tablist">
            <li role="presentation" class="active session-detail-tab" [class.active]="isCurrentTab('description')">
                <a aria-controls="description" role="tab" data-toggle="tab" (click)="updateActiveTab('description')">
                    <h3><br>{{ 'session-details.description' | translate}}</h3>
                </a>
            </li>
            <li *jhiHasAnyAuthority="'ROLE_ADMIN'" role="presentation" class="session-detail-tab"
                [class.active]="isCurrentTab('search-module')">
                <a aria-controls="search-module" role="tab" data-toggle="tab"
                   (click)="updateActiveTab('search-module')">
                    <h3>{{ 'session-details.trainerSearch' | translate}}</h3>
                </a>
            </li>
            <li *jhiHasAnyAuthority="'ROLE_ADMIN'" role="presentation" class="session-detail-tab"
                [class.active]="isCurrentTab('answers-module')">
                <a aria-controls="answers-module" role="tab" data-toggle="tab"
                   (click)="updateActiveTab('answers-module')">
                    <h3>{{ 'session-details.trainerAnswers' | translate}}</h3>
                </a>
            </li>
            <li role="presentation" class="session-detail-tab" [class.active]="isCurrentTab('students-module')">
                <a aria-controls="students-module" role="tab" data-toggle="tab"
                   (click)="updateActiveTab('students-module')">
                    <h3><br>{{ 'session-details.students' | translate}}</h3>
                </a>
            </li>
            <li role="presentation" class="session-detail-tab" [class.active]="isCurrentTab('evaluations-module')">
                <a aria-controls="evaluations-module" role="tab" data-toggle="tab"
                   (click)="updateActiveTab('evaluations-module')">
                    <h3><br>{{ 'session-details.evaluations.title' | translate}}</h3>
                </a>
            </li>
            <li role="presentation" class="session-detail-tab" [class.active]="isCurrentTab('survey-monkey-module')">
                <a aria-controls="survey-monkey-module" role="tab" data-toggle="tab"
                   (click)="updateActiveTab('survey-monkey-module')">
                    <h3><br>{{ 'Survey' }}</h3>
                </a>
            </li>
        </ul>

        <div class="tab-content">
            <!-- DESCRIPTION TAB -->
            <div role="tabpanel" class="tab-pane active formateurs" id="description"
                 [class.active]="isCurrentTab('description')">
                <session-detail-description [session]="session">
                </session-detail-description>
            </div>

            <!-- SEARCH TRAINER TAB -->
            <div *jhiHasAnyAuthority="'ROLE_ADMIN'" role="tabpanel" class="tab-pane formateurs search-formateur" id="search-module"
                 [class.active]="isCurrentTab('search-module')">
                <staffing-search [session]="session"
                                 [responses]="trainersResponses"
                                 [selectedTrainers]="selectedTrainers"
                                 [sendMailFunction]="sendMail()">
                </staffing-search>
            </div>

            <!-- RESULT SEARCH TRAINER TAB -->
            <div *jhiHasAnyAuthority="'ROLE_ADMIN'" role="tabpanel" class="tab-pane formateurs" id="answers-module"
                 [class.active]="isCurrentTab('answers-module')">
                <staffing-results [session]="session"
                                  [trainers]="selectedTrainers"
                                  [responses]="trainersResponses"
                                  [sendMailFunction]="sendMail()">
                </staffing-results>
            </div>

            <!-- STUDENTS REGISTRATION TAB -->
            <div role="tabpanel" class="tab-pane" id="students-module" [class.active]="isCurrentTab('students-module')">
                <session-details-registration [sessionId]="sessionId"
                                              [session]="session"
                                              (priceUpdated)="priceUpdated($event)"></session-details-registration>
            </div>

            <div role="tabpanel" class="tab-pane" id="evaluations-module" [class.active]="isCurrentTab('evaluations-module')">
                <session-detail-trainer-evaluation [sessionId]="sessionId"></session-detail-trainer-evaluation>
                <hr>
                <session-detail-evaluations [sessionId]="sessionId"></session-detail-evaluations>
            </div>

            <div role="tabpanel" class="tab-pane" id="survey-monkey-module" [class.active]="isCurrentTab('survey-monkey-module')">
                <session-survey-monkey [sessionId]="sessionId"></session-survey-monkey>
            </div>

            <!-- EDIT BUtton -->
            <div *jhiHasAnyAuthority="'ROLE_ADMIN'">
                <button *ngIf="isCurrentTab('description')" class="btn btn-primary btn-round btn-lg"
                        uiSref="session-update"
                        [uiParams]="{ id: session.id }"><i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/detail.component.html